import 'react-toastify/dist/ReactToastify.css'

import { Dialog, Transition } from '@headlessui/react'
import useTranslation from 'next-translate/useTranslation'
import { Fragment, useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'

import { changeNsType } from '@/api/dns/changeNsType'
import { getDomainById } from '@/api/dns/getDomain'
import { getNstypes } from '@/api/dns/getNstypes'
import InputNsSection from '@/components/dnsManagement/InputNsSection'
import Select from '@/components/dnsManagement/Select'
import ButtonText from '@/components/ui/Typo/ButtonText'
import Subtitle from '@/components/ui/Typo/Subtitle'
import { NAMESPACE_MANAGEMENT } from '@/res/namespaces'
import { IDnsDomain } from '@/types/DnsDomain'

interface Props {
  onClose: () => void
  id: string
}

const ControlsPopup: React.FC<Props> = ({ onClose, id }) => {
  const { t } = useTranslation(NAMESPACE_MANAGEMENT)
  const notifySuccess = () => toast.success(t('ns_popup.ns_changed'))

  const [domains, setDomains] = useState<IDnsDomain[]>([])
  const [domainData, setDomainData] = useState<IDnsDomain | null>(null)
  const [selectedNsType, setSelectedNsType] = useState<string | null>(null)
  const [ns1, setNs1] = useState(' ')
  const [ns2, setNs2] = useState(' ')

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await getNstypes()

        setDomains(res)
      } catch (err) {
        return err
      }
    }
    const getDomain = async (id: string) => {
      try {
        const res = await getDomainById(id)

        setDomainData(res)
        setNs1(res.ns1)
        setNs2(res.ns2)
        setSelectedNsType(res.name_server_type)
      } catch (err) {
        return err
      }
    }
    getDomain(id)
    getData()
  }, [id])
  return (
    <>
      <ToastContainer />
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={() => onClose()}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-[420px] max-w-4xl transform rounded-2xl bg-white desktop:px-8 py-6 small:px-20 px-4 text-left align-middle shadow-xl transition-all">
                  <form
                    className="flex flex-col justify-between min-h-[270px]"
                    onSubmit={async (e) => {
                      e.preventDefault()
                      if (
                        selectedNsType === domainData?.name_server_type &&
                        selectedNsType != 'name_server_type'
                      ) {
                        onClose()
                        return
                      }

                      if (selectedNsType === 'own_name_server') {
                        await changeNsType({ id, ns1, ns2, selectedNsType })
                      } else {
                        await changeNsType({ id, selectedNsType })
                      }
                      notifySuccess()
                      setTimeout(() => {
                        window.location.reload()
                      }, 1500)
                      onClose()
                    }}
                  >
                    <div>
                      <Subtitle
                        uppercase={false}
                        weight="font-semibold"
                        className="my-3 text-center"
                        color="text-primary"
                      >
                        {t('ns_popup.ns_server_management')}
                      </Subtitle>
                      <div className="flex items-center justify-center">
                        <div className="relative w-full max-w-xs mx-auto">
                          <Select
                            options={domains}
                            selectedOption={selectedNsType}
                            handelChange={(event: any) => {
                              setSelectedNsType(event)
                            }}
                          />

                          {selectedNsType === 'own_name_server' ? (
                            <InputNsSection
                              ns1={ns1 || ' '}
                              ns2={ns2 || ' '}
                              setNs1={setNs1}
                              setNs2={setNs2}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center mt-5 gap-x-3">
                      <button
                        type="submit"
                        className="px-6 py-2 rounded-lg outline-none bg-primary hover:opacity-90 active:scale-x-95"
                      >
                        <ButtonText size="small">
                          {t('ns_popup.save')}
                        </ButtonText>
                      </button>
                      <button
                        type="submit"
                        onClick={() => onClose()}
                        className="px-6 py-2 bg-red-600 rounded-lg outline-none hover:opacity-90 active:scale-x-95"
                      >
                        <ButtonText size="small">
                          {t('ns_popup.cancel')}
                        </ButtonText>
                      </button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default ControlsPopup
